export default () => ({
	isFooterMenuOpen: false,

	init() {
		// No-op for now
	},

	toggleFooterMenu() {
		this.isFooterMenuOpen = !this.isFooterMenuOpen
		if (this.isFooterMenuOpen) {
			this.scrollToBottom()
		}
	},

	scrollToBottom() {
		// Use setTimeout to ensure DOM updates before scrolling
		setTimeout(() => {
			window.scrollTo({
				top: document.body.scrollHeight,
				behavior: 'smooth',
			})
		}, 100)
	},

	isExternalLink(url) {
		return /^(https?:)?\/\//.test(url)
	},
})
